(function () {
  'use strict';

  function pad(num) {
    return String(num).padStart(2, '0');
  }

  function initCountdown(el) {
    var hours = parseFloat(el.getAttribute('data-hours')) || 24;
    var storageKey = el.getAttribute('data-storage-key');
    var durationMs = hours * 60 * 60 * 1000;
    var endTime;
    var stored = null;

    try {
      var raw = window.localStorage.getItem(storageKey);
      stored = raw ? JSON.parse(raw) : null;
    } catch (e) {
      stored = null;
    }

    var hasValidStoredState =
      stored &&
      typeof stored.endTime === 'number' &&
      typeof stored.hours === 'number' &&
      stored.hours === hours &&
      stored.endTime > Date.now();

    if (hasValidStoredState) {
      endTime = stored.endTime;
    } else {
      endTime = Date.now() + durationMs;
      persist(storageKey, endTime, hours);
    }

    var hrsEl = el.querySelector('[data-hlp-hrs]');
    var minEl = el.querySelector('[data-hlp-min]');
    var secEl = el.querySelector('[data-hlp-sec]');

    function tick() {
      var remaining = endTime - Date.now();

      if (remaining <= 0) {
        endTime = Date.now() + durationMs;
        persist(storageKey, endTime, hours);
        remaining = durationMs;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var h = Math.floor(totalSeconds / 3600);
      var m = Math.floor((totalSeconds % 3600) / 60);
      var s = totalSeconds % 60;

      if (hrsEl) hrsEl.textContent = pad(h);
      if (minEl) minEl.textContent = pad(m);
      if (secEl) secEl.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  }

  function persist(storageKey, endTime, hours) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify({ endTime: endTime, hours: hours }));
    } catch (e) {
      /* localStorage unavailable, timer will just run for this page view */
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var timers = document.querySelectorAll('[data-hlp-countdown]');
    timers.forEach(initCountdown);
  });
})();